import initModals from './components/modal';
import initAppearAnim from './utils/appear-anim';
import initNavigation from './components/navigation';
import initHeaderHome from './components/header-home';
import initHeaderSingle from './components/slider-single';
import initTabs from './components/tab-single';
import initSizeSelect from './components/size-select-single';


// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);


// Utils
initAppearAnim();

// Components (En dernier sinon les bouton modals dans un swiper ne s'initialise pas)
initNavigation();
initHeaderHome();
initHeaderSingle();
initTabs();
initSizeSelect();
initModals();
